NtechApp.ViewBusinessAccAboutModalLocationMap = function($view, mapStartCoords) {
    var me = this;

    this._$view = null;
    this._click = null;

    this._mapStartCoords = null;

    this._form = null;
    this._$form = null;
    this._map = null;
    this._mapMarker = null;

    this._construct = function() {
        me._$view = $view;
        me._click = new NtechApp.TouchClickEvent();

        me._mapStartCoords = mapStartCoords;
        me._init();

        me._bindEvents();
    }

    this._bindEvents = function() {
        $(window).on(NtechApp.ViewBusinessAccAboutModalLocationMap.EVENT_WINDOW_RESIZE, function() {
            me._updateMapHeight();
        });

        me._click.listen(me._$view, "[data-triggerShowMapPopup]", function() {
            me._form.forceCacheCallback();
            me._form.load("fakecacheroute", function() {
                me._afterFormLoad.call(me);
            });
        });
    }

    this._unbindEvents = function() {
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.ViewBusinessAccAboutModalLocationMap.EVENT_WINDOW_RESIZE = "resize.NtechApp.ViewBusinessAccAboutModalMap";

NtechApp.proto(NtechApp.ViewBusinessAccAboutModalLocationMap, {
    _init: function() {
        var me = this;

        me._form = new NtechApp.ModalForm(NtechApp.ModalForm.CACHE);
        me._form.setFormView($("#viewMapForm"));

        me._$form = $("body").find("#viewMapForm");
        
        me._createForm();
        me._bindFormEvents();
    },

    _createForm: function() {
        this._$form.find(".mapWrapper").css({
            position: "relative",
            width: "100%"
        });

        this._$form.find(".mapMessage").css({
            position: "absolute",
            left: "0px",
            top: "0px",
            zIndex: 2,
            background: "#37bdb1",
            color: "white",
            padding: "8px 17px",
            fontSize: "12px"
        });

        this._$form.find("#map").css({
            width: "100%",
            zIndex: "1",
            height: "200px"
        });

        var startCoords = this._mapStartCoords;
        this._map = new google.maps.Map(this._$form.find("#map").get(0), {
            center: startCoords,
            zoom: 14,
            mapTypeControl: false
        });

        this._clearMarker();
        this._createMarker(this._mapStartCoords);
    },

    _clearMarker: function() {
        if(this._mapMarker != null)
            this._mapMarker.setMap(null);

        this._mapMarker = null;
    },

    _createMarker: function(coords) {
        var me = this;

        var coords = {
            lat: parseFloat(coords.lat),
            lng: parseFloat(coords.lng)
        };

        this._mapMarker = new google.maps.Marker({
            position: coords,
            map: this._map
        });
    },

    _bindFormEvents: function() {
        var me = this;

        this._click.listen(this._$form.find(".formHeader .close .button"), function() {
            me._form.unload();
        });

        this._click.listen(this._$form.find("[data-cancelBut]"), function() {
            me._form.unload();
        });

        this._click.listen(this._$form.find("[data-confirmBut]"), function() {
            me._form.unload();
        });
    },

    _updateMapHeight: function() {
        var topHeight = this._$form.find(".formHeader").outerHeight();
        var bottomHeight = this._$form.find(".formControls").outerHeight();
        var formHeight = this._$form.outerHeight();
        var newHeight = formHeight - topHeight - bottomHeight - 2;

        this._$form.find("#mapWrapper").height(newHeight);
        this._$form.find("#map").height(newHeight);
    },

    _afterFormLoad: function() {
        $(window).trigger(NtechApp.ViewBusinessAccAboutModalLocationMap.EVENT_WINDOW_RESIZE);
        google.maps.event.trigger(this._map, 'resize');

        this._map.setCenter(new google.maps.LatLng(this._mapStartCoords));
    }
});